import * as React from 'react';
import {useState} from 'react';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import {useTranslation} from 'react-i18next';
import {Paper} from '@mui/material';
import {useAgyleConfigStyles} from '../agyle_configuration';
import AssessmentList from './components/assessmentList';
import AssessmentConfiguration from './components/assessmentConfiguration';
import AssessmentMandatoryConfiguration from './components/assessmentMandatoryConfiguration';

const WardAssessments = () => {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();

    const [switchValue, setSwitchValue] = useState('list');

    const renderContext = () => {
        switch (switchValue) {
            case 'list':
                return <AssessmentList/>;
            case 'configurations':
                return <AssessmentConfiguration/>;
            case 'mandatory':
                return <AssessmentMandatoryConfiguration/>;
            default:
                return null;
        }
    };

    return (
        <>
            <AgyleBlockSwitch
                onChange={setSwitchValue}
                value={switchValue}
                valueObject={{
                    'true': 'list',
                    'false': 'mandatory',
                    'null': 'configurations',
                }}
                customLabels={{
                    yes: t('Assessment list'),
                    no: t('Mandatory configuration'),
                    empty: t('Assessment configuration'),
                }}
                nullState
            />

            <Paper className={classes.paper} style={{marginTop: 10}}>
                {renderContext()}
            </Paper>
        </>
    );
};

export default WardAssessments;